import { render, staticRenderFns } from "./BookingInfoPage.vue?vue&type=template&id=498f5e2c&"
import script from "./BookingInfoPage.vue?vue&type=script&setup=true&lang=js&"
export * from "./BookingInfoPage.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./BookingInfoPage.vue?vue&type=style&index=0&id=498f5e2c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports